<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex md8 sm12 lg10 offset-md1 offset-lg1>
                <reports-table @refresh="getItems" :total="total" :loading="loading" :items="items"></reports-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import ReportsTable from './travelWarrants/Table'
    export default {
        name: "TravelWarrants",
        components: {ReportsTable},
        data: () => ({
            items: [],
            initial: true,
            loading: false,
            total: 0,
            pagination: {}
        }),
        created () {

        },
        methods: {
            getItems(data = null){
                this.pagination = data;
                if(this.initial){
                    this.setFetching(true);
                }
                this.loading = true;
                data.include = 'users';
                if(data.export == 1){
                    this.repositories.travelWarrant.searchAndExport(data).then(response => {
                    }).finally(() => {
                        this.loading = this.initial = false;
                        this.setFetching(false);
                    });
                }
                else{
                    this.repositories.travelWarrant.search(data).then(response => {
                        this.items = response.data.data;
                        this.total = response.data.meta.pagination.total;
                    }).finally(() => {
                        this.loading = this.initial = false;
                        this.setFetching(false);
                    });
                }

            }
        }
    }
</script>

<style scoped>

</style>
